
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17.09 4.56002C16.39 3.53002 15.59 2.57002 14.69 1.71002C14.34 1.37002 13.75 1.69002 13.85 2.17002C14.04 3.11002 14.24 4.35002 14.24 5.46002C14.24 7.52002 12.89 9.19002 10.83 9.19002C9.29 9.19002 8.03 8.26002 7.48 6.93002C7.38 6.73002 7.34 6.61002 7.28 6.39002C7.17 5.97002 6.62 5.84002 6.38 6.21002C6.2 6.48002 6.03 6.75002 5.87 7.04002C4.68 9.08002 4 11.46 4 14C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14C20 10.51 18.92 7.27002 17.09 4.56002ZM11.71 19C9.93 19 8.49 17.6 8.49 15.86C8.49 14.24 9.54 13.1 11.3 12.74C12.77 12.44 14.28 11.81 15.33 10.82C15.61 10.56 16.07 10.68 16.15 11.05C16.38 12.07 16.5 13.13 16.5 14.2C16.51 16.85 14.36 19 11.71 19Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-whatshot`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconWhatshot

    ```js
    <b-new-b-icon-whatshot />
    ```
</docs>


